export const columns: any = [
  {
    title: 'ID',
    colSize: '4',
    sortable: true,
    sort: 'desc',
    sortName: 'PartTerminologyId',
    active: false,
    col: 'part_terminology_id'
  },
  {
    title: 'Part type',
    colSize: '17',
    sortable: true,
    sort: 'desc',
    sortName: 'partTerminologyName',
    active: false,
    col: 'part_terminology_name',
  },
  {
    title: 'Category',
    colSize: '10',
    sortable: true,
    sort: 'desc',
    sortName: 'categoryName',
    active: false,
    col: 'category_name',
  },
  {
    title: 'Subcategory',
    colSize: '17',
    sortable: true,
    sort: 'desc',
    sortName: 'subCategoryName',
    active: false,
    col: 'sub_category_name',
  },
];
